var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M16.5 6h-3a1 1 0 0 0-1 1v3h4a.35.35 0 0 1 .34.46l-.74 2.2a.5.5 0 0 1-.47.34H12.5v7.5a.5.5 0 0 1-.5.5H9.5a.5.5 0 0 1-.5-.5V13H7.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5H9V7a4 4 0 0 1 4-4h3.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5c16bed8.svg";
export { ForwardRef as ReactComponent };